module.exports = __webpack_public_path__ + "static/media/RationalDisplay-Light.5f8780aa.svg";